import React from "react";
import { BrowserRouter, Routes, Route, Link, NavLink } from "react-router-dom"
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import { useLanguage } from '../i18n/translations';
export default function Uslovi({ categories }) {
    const { translate } = useLanguage();
    return (
        <div className="bg-gray-100 text-gray-800">
            <SEO
                title="Uslovi korišćenja - Bulka Ceramics"
                description=""
                type="website"
                name="Bulka Ceramics"
            />
            <div className="container mx-auto p-6">



                <div className="bg-white p-6 rounded-lg shadow">
                    <h1 className="text-2xl font-bold mb-4">{translate("Terms of Use")}</h1>
                    <p className="mb-2">{translate("By using this site, you agree to the following terms of use:")}</p>
                    <h2 className="text-xl font-semibold mb-2">{translate("General Terms")}</h2>
                    <p className="mb-2">{translate("All content on this site, including text, images, and graphics, is protected by copyright. Use of any part of the content without our permission is not allowed.")}</p>
                    <h2 className="text-xl font-semibold mb-2">{translate("Orders")}</h2>
                    <p className="mb-2">{translate("When ordering products, the user undertakes to provide accurate and complete information. If an error occurs in the order, we reserve the right to cancel it.")}</p>
                    <h2 className="text-xl font-semibold mb-2">{translate("Limitation of Liability")}</h2>
                    <p className="mb-2">{translate("We are not responsible for any damages or losses that may result from the use of our products or services. We recommend that you carefully read all information before making a purchase.")}</p>
                    <h2 className="text-xl font-semibold mb-2">{translate("Contact")}</h2>
                    <p>{translate("For any additional information or questions regarding our terms of use, feel free to contact us at email:")} <a href="mailto:contact@bulkaceramics.com" className="text-blue-500">contact@bulkaceramics.com</a>.</p>
                </div>
            </div>

            <Footer categories={categories} />
        </div>
    )
}